import type {
    ComposableOptionsBase
} from '~/types';
import * as v from 'valibot';
import type { GenericSchema } from 'valibot';
import { stringOrNull } from 'x1-base/utils';


export interface UseValibotUtilsOptions extends ComposableOptionsBase {}

export function useValibotUtils(options: Partial<UseValibotUtilsOptions> = {}) {
    
    function vNullableDefaultString(schema: GenericSchema) {
        return v.optional(
            v.union([
                schema,
                v.nullable(v.pipe(
                    v.unknown(),
                    v.string(),
                    v.trim(),
                    v.empty(),
                    v.transform((input: string) => stringOrNull(input))
                ))
            ]),
            null
        );
    }

    return {
        vNullableDefaultString
    };
}
